import {z} from 'zod';
import { b2bCalendarDay } from './b2bCalendarDay';
import { b2bCalendarImage } from './b2bCalendarImage';

export const b2bCalendar = z.object({
  id: z.coerce.number(),
  isCalendarActive: z.coerce.boolean().default(false),
  notice: z.string().nullable(),
  timeZone: z.object({
    id: z.coerce.number(),
    timeZoneIdentifier: z.string(),
  }),
  b2bCalendarDays: z.array(b2bCalendarDay).nullable(),
  b2bCalendarImages: z.array(b2bCalendarImage).nullable(),
});

export type b2bCalendar = z.infer<typeof b2bCalendar>;




